import PricingPage from '@components/containers/b2b/PricingPage';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const B2bPricing: FC = () => (
    <AppLayout>
        <PricingPage />
    </AppLayout>
);

export default B2bPricing;
